var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_832_213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 0.5C4.3125 0.5 3.75 1.0625 3.75 1.75V19.25C3.75 19.9375 4.3125 20.5 5 20.5H17.5C18.1875 20.5 18.75 19.9375 18.75 19.25V5.5L13.75 0.5H5Z",
    fill: "#E2E5E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 5.5H18.75L13.75 0.5V4.25C13.75 4.9375 14.3125 5.5 15 5.5Z",
    fill: "#B0B7BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 9.25L15 5.5H18.75V9.25Z",
    fill: "#CAD1D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 16.75C16.25 17.0938 15.9688 17.375 15.625 17.375H1.875C1.53125 17.375 1.25 17.0938 1.25 16.75V10.5C1.25 10.1562 1.53125 9.875 1.875 9.875H15.625C15.9688 9.875 16.25 10.1562 16.25 10.5V16.75Z",
    fill: "#F15642"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.97437 12.3419C3.97437 12.1769 4.10437 11.9969 4.31374 11.9969H5.46811C6.11811 11.9969 6.70312 12.4319 6.70312 13.2656C6.70312 14.0556 6.11811 14.4956 5.46811 14.4956H4.63374V15.1556C4.63374 15.3756 4.49374 15.5 4.31374 15.5C4.14874 15.5 3.97437 15.3756 3.97437 15.1556V12.3419ZM4.63374 12.6262V13.8712H5.46811C5.80311 13.8712 6.06811 13.5756 6.06811 13.2656C6.06811 12.9162 5.80311 12.6262 5.46811 12.6262H4.63374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.68191 15.5C7.51691 15.5 7.33691 15.41 7.33691 15.1906V12.3519C7.33691 12.1725 7.51691 12.0419 7.68191 12.0419H8.82629C11.11 12.0419 11.06 15.5 8.87129 15.5H7.68191ZM7.99691 12.6519V14.8906H8.82629C10.1757 14.8906 10.2357 12.6519 8.82629 12.6519H7.99691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8699 12.6919V13.4862H13.1443C13.3243 13.4862 13.5043 13.6662 13.5043 13.8406C13.5043 14.0056 13.3243 14.1406 13.1443 14.1406H11.8699V15.19C11.8699 15.365 11.7456 15.4994 11.5706 15.4994C11.3506 15.4994 11.2162 15.365 11.2162 15.19V12.3512C11.2162 12.1719 11.3512 12.0412 11.5706 12.0412H13.3249C13.5449 12.0412 13.6749 12.1719 13.6749 12.3512C13.6749 12.5112 13.5449 12.6912 13.3249 12.6912H11.8699V12.6919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.625 17.375H3.75V18H15.625C15.9688 18 16.25 17.7188 16.25 17.375V16.75C16.25 17.0938 15.9688 17.375 15.625 17.375Z",
    fill: "#CAD1D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_832_213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/PDF.e062c634e051cec1ed5b810962c93d5d.svg";
export { ForwardRef as ReactComponent };